import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DotCmsDynamicCategories } from '../dot-cms-category-tile/dot-cms-category-tile.component';

@Component({
  selector: 'custom-dot-cms-category-swiper',
  templateUrl: './dot-cms-category-swiper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotCmsCategorySwiperComponent {
  @Input() dynamicCategory: DotCmsDynamicCategories;
}
